import { useTheme } from "@emotion/react";
import { Button, Container, Grid, Paper } from "@mui/material";
import { Fragment } from "react";
import ActivationRequestComponent from "../components/activationRequest/activationRequest.component";
import logo from "../assets/images/Acquaount-logo.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const ActivationRequestPage = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const success = useSelector((state) => state?.signup?.success);

  return (
    <Fragment>
      <div
        style={{
          background: theme.palette.primary.main,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={5}>
              <Paper elevation={3} style={{ padding: "20px" }}>
                <ActivationRequestComponent logo={logo} />
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={2}
                  style={{ marginTop: "5px" }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <Button
                      variant={success ? "contained" : "outlined"}
                      color="primary"
                      fullWidth
                      href="/login"
                    >
                      {t("login")}
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </div>
    </Fragment>
  );
};

export default ActivationRequestPage;
